const getTags = (values) => {
  let tags = [];

  let affiliation = {
    "Name": "Affiliation"
  };

  if (values["other_affiliation"]) {
    affiliation.value = values["other_affiliation"];
  }
  else {
    affiliation.value = values["affiliation"]
  }
  tags.push(affiliation);

  if (values["TCP"]) {
    tags.push({
      "Name": "TCP",
      "Value": values["TCP"]
    });
  }

  if (values["PTAO"]) {
    tags.push({
      "Name": "PTAO",
      "Value": values["PTAO"]
    });
  }

  if (values["PTAO:OTE"]) {
    tags.push({
      "Name": "PTAO:OTE",
      "Value": values["PTAO:OTE"]
    });
  }

  if (values["FDM"]) {
    tags.push({
      "Name": "FDM",
      "Value": values["FDM"]
    });
  }

  if (values["billing_contact"]) {
    tags.push({
      "Name": "Billing Contact",
      "Value": values["billing_contact"]
    });
  }

  return tags;
}

const getFlagParams = (config, fname) => {
  const fe = config.flag_parameters
  for (let i = 0; i < fe.length; i++) {
    if (fe[i].name === fname) {
      const flag = fe[i]
      if (!flag.expire_days) {
        flag.expire_days = 0;
      }
      if (!flag.warn_days) {
        flag.warn_days = 0;
      }
      return flag
    }
  }
  return {
    name: fname,
    expire_days: 0,
    warn_days: 0
  }
}

const getComplianceFlags = (values) => {
  const array = values["compliance"]
  if (array === undefined) {
    return null
  }

  const cflags = []

  array.forEach(fname => {
    var compliance;
    if (fname !== "Other") {
      compliance = {
        "Name": fname
      }
    } else {
      compliance = {
        "Name": "HSD:" + values["sensitivity"]
      }
    }
    cflags.push(compliance);
  });

  return cflags;
}

const baseConfig = [
  {
    size: "small",
    cores: "4",
    memory: "16"
  },
  {
    size: "medium",
    cores: "8",
    memory: "32"
  },
  {
    size: "large",
    cores: "16",
    memory: "64"
  },
  {
    size: "xlarge",
    cores: "16",
    memory: "124"
  }
]

const getCores = (values) => {
  var i
  for (i = 0; i < baseConfig.length; i++) {
    if (baseConfig[i].size === values["base_configuration"]) {
      return  {
        "name": "Cores",
        "value": baseConfig[i].cores
      }
    }
  }
  return  {
      "name": "Cores",
      "value": -1
  }
}

const getMemory = (values) => {
  var i
  for (i = 0; i < baseConfig.length; i++) {
    if (baseConfig[i].size === values["base_configuration"]) {
      return  {
        "name": "RAMinGB",
        "value": baseConfig[i].memory
      }
    }
  }
  return  {
      "name": "RAMinGB",
      "value": -1
  }
}

// if "desc" is defined it's appended to name to provide the description
// types:
//   "data" - data analysis
//   "database" - database software
//   "bio" - bioinformatics
//   "image" - image analysis
const softwareOptions = [
  {
    name: "bowtie2",
    plaforms: [ "Linux", "Windows" ],
    type: "bio"
  },
  {
    name: "cTAKES",
    plaforms: [ "Linux", "Windows" ],
    type: "data"
  },
  {
    name: "HISAT2",
    plaforms: [ "Linux", "Windows" ],
    type: "bio"
  },
  {
    name: "IDL",
    desc: "(limited licenses available)",
    plaforms: [ "Linux" ],
    type: "data"
  },
  {
    name: "ImageJ",
    plaforms: [ "Linux", "Windows" ],
    type: "image"
  },
  {
    name: "KNIME",
    plaforms: [ "Linux" ],
    type: "image"
  },
  {
    name: "MariaDB",
    plaforms: [ "Linux", "Windows" ],
    type: "database"
  },
  {
    name: "MATLAB",
    desc: "(licensed for UVA affiliates only)",
    plaforms: [ "Linux", "Windows" ],
    type: "data"
  },
  {
    name: "Microsoft SQL Server",
    desc: "(user-provided license required)",
    plaforms: [ "Windows" ],
    type: "database"
  },
  {
    name: "MongoDB",
    plaforms: [ "Linux", "Windows" ],
    type: "database"
  },
  {
    name: "MySQL Workbench",
    plaforms: [ "Linux", "Windows" ],
    type: "database"
  },
  {
    name: "OpenCV",
    plaforms: [ "Linux" ],
    type: "image"
  },
  {
    name: "PostgreSQL",
    plaforms: [ "Linux", "Windows" ],
    type: "database"
  },
  {
    name: "SAS",
    desc: "(limited licenses available)",
    plaforms: [ "Linux", "Windows" ],
    type: "data"
  },
  {
    name: "SPSS",
    desc: "(limited licenses available)",
    plaforms: [ "Windows" ],
    type: "data"
  },
  {
    name: "Stata",
    desc: "(user-provided license required)",
    plaforms: [ "Linux", "Windows" ],
    type: "data"
  },
]

const getOSOptions = (os) => {
  let osOpt = {}
  var i
  for (i = 0; i < softwareOptions.length; i++) {
    if (softwareOptions[i].plaforms.includes(os)) {
      const stype = softwareOptions[i].type
      if (stype) {
        if (! osOpt[stype]) {
          osOpt[stype] = []
        }
        let sdesc = softwareOptions[i].name
        if (softwareOptions[i].desc) {
          sdesc = sdesc + " " + softwareOptions[i].desc
        }
        osOpt[stype].push({
          name: softwareOptions[i].name,
          desc: sdesc
        })
      }
    }
  }
  return osOpt
}

// const centOSbioinformaticsOptions = ["cufflinks","BEDtools","SAMtools","PeakSeq","Sicer","Plink"];

// const windowsBioinformaticsOptions = ["cufflinks","BEDtools","SAMtools","PeakSeq","Sicer","Plink"];
// const windowsImageOptions = ["Axiovision"];

export {
  getTags, getComplianceFlags, getFlagParams, baseConfig, getCores, getMemory, getOSOptions,
};
